export class PlacementMetadata{
  amount?: string;
  amountType?: string;
  location?: string;
  productCategory?: string;
  brand?: string;
  sku?: string;
  loyaltyId?: string;

  constructor(dataset: any = {}){
    this.amount = dataset.amount;
    this.amountType = dataset.amountType;
    this.location = dataset.location;
    this.productCategory = dataset.productCategory;
    this.brand = dataset.brand;
    this.sku = dataset.sku;
    this.loyaltyId = dataset.loyaltyId;
  }
}
